module.exports = __webpack_public_path__ + "static/media/modal-close-icon-white.a32515fb.svg";